module.exports = __webpack_public_path__ + "static/img/dl_google.5a2bd764.png";